import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { resetMsg } from 'Redux/actions/login';

const useShowMsg = auth => {
  const [showMsg, setShowMsg] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    // Coded failures render actionable UI (resend link, contact support), so they
    // stay until the next attempt clears them. Only untyped messages time out.
    if (auth.error?.code) return;
    if (auth?.success || auth.error !== null) {
      setShowMsg(true);
      setTimeout(() => {
        setShowMsg(false);
        dispatch(resetMsg());
      }, 5000);
    }
  }, [auth.success, auth.error]);

  return { showMsg };
};

export default useShowMsg;
